
import Vue from 'vue'
import VueRouter from 'vue-router'
// 定义路径为 ../views/Home.vue 的为组件Home
import Home from '../views/Home.vue'
// 挂载vue
Vue.use(VueRouter)
// 路由管理方式
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
]

const router = new VueRouter({
  // mode: 'history',
  routes
})

export default router
